// errors
export const ERROR_TECNICO = "error-1";
export const TURNO_ASIGNADO = "error-2";
export const SUC_SIN_CUPO = "error-3";
export const OTORGADO = "gracias";
